import { type SupportedLocale } from '@zep-us/i18n';
import {
  bn,
  de,
  enUS,
  es,
  et,
  fr,
  hi,
  id,
  it,
  ja,
  km,
  ko,
  ms,
  nl,
  pl,
  pt,
  ptBR,
  ru,
  ta,
  te,
  th,
  tr,
  uz,
  vi,
  zhCN,
  zhHK,
  zhTW,
} from 'date-fns/locale';

const LOCALE_MAP = {
  en: enUS,
  ko,
  ja,
  id,
  th,
  fil: enUS, // Filipino fallback to English
  vi,
  ms,
  uz,
  fr,
  km,
  ru,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  es,
  pt,
  de,
  it,
  tr,
  nl,
  pl,
  'pt-BR': ptBR,
  'en-SG': enUS, // English (Singapore) fallback to English (US)
  'hi-IN': hi,
  'bn-IN': bn,
  'te-IN': te,
  'ta-IN': ta,
  'pa-IN': enUS, // Punjabi fallback to English (no date-fns support)
  'ml-IN': enUS, // Malayalam fallback to English (no date-fns support)
  et,
  'zh-HK': zhHK,
} as const;

export function getDateFnsLocale(locale?: SupportedLocale) {
  if (!locale) return enUS;
  return LOCALE_MAP[locale] || enUS; // 기본적으로 영어로 fallback
}
